import { render, staticRenderFns } from "./QualificationsAdminForm.vue?vue&type=template&id=418c1aff&scoped=true&"
import script from "./QualificationsAdminForm.vue?vue&type=script&lang=js&"
export * from "./QualificationsAdminForm.vue?vue&type=script&lang=js&"
import style0 from "./QualificationsAdminForm.vue?vue&type=style&index=0&id=418c1aff&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418c1aff",
  null
  
)

export default component.exports